import type { Routes } from "@angular/router";
import { applicationFeatureType } from "@core/auth/permissions";
import { withPermissions } from "@core/auth/with-permissions";
import { alreadyLoggedInGuard } from "@core/guards/already-logged-in.guard";
import { authGuard } from "@core/guards/auth.guard";
import { permissionGuard } from "@core/guards/permission.guard";
import { unsavedChangesGuard } from "@core/guards/unsaved-changes.guard";
import { Container } from "./container";
import { logHandlingMode } from "./loghandling/loghandling";

export const routes: Routes = [
  {
    path: "",
    component: Container,
    canActivateChild: [authGuard],
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadComponent: () => import("./dashboard/dashboard.view").then((m) => m.DashboardView),
      },
      // One route per mode so each mode requires its own permission
      {
        path: `loghandling/${logHandlingMode.enum.Signing}`,
        canActivate: [permissionGuard],
        data: {
          mode: logHandlingMode.enum.Signing,
          ...withPermissions([applicationFeatureType.enum.AccessLogSign]),
        },
        loadComponent: () =>
          import("./loghandling/log-handling.view").then((m) => m.LogHandlingView),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: `loghandling/${logHandlingMode.enum.Countersigning}`,
        canActivate: [permissionGuard],
        data: {
          mode: logHandlingMode.enum.Countersigning,
          ...withPermissions([applicationFeatureType.enum.AccessLogCountersign]),
        },
        loadComponent: () =>
          import("./loghandling/log-handling.view").then((m) => m.LogHandlingView),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: "history",
        canActivate: [permissionGuard],
        data: {
          ...withPermissions([applicationFeatureType.enum.AccessLogHistory]),
        },
        loadComponent: () => import("./history/history.view").then((m) => m.HistoryView),
      },
      {
        path: "profile",
        loadComponent: () => import("./profile/profile.view").then((m) => m.ProfileView),
        children: [
          {
            path: "",
            redirectTo: "permissions",
            pathMatch: "full",
          },
          {
            path: "permissions",
            loadComponent: () =>
              import("./profile/-partials/profile-permission-table-card").then(
                (m) => m.ProfilePermissionTableCard,
              ),
          },
          {
            path: "settings",
            loadComponent: () =>
              import("./profile/-partials/profile-settings-card").then(
                (m) => m.ProfileSettingsCard,
              ),
          },
        ],
      },
      {
        path: "admin",
        loadChildren: () => import("./admin/admin.routes"),
      },
    ],
  },
  {
    path: "forgot-password",
    canActivate: [alreadyLoggedInGuard],
    loadComponent: () =>  import("./forgot-password/forgot-password.view").then((m) => m.ForgotPasswordView,),
  },
  {
    path: "reset-password",
    canActivate: [alreadyLoggedInGuard],
    loadComponent: () => import("./reset-password/reset-password.view").then((m) => m.ResetPasswordView,),
  },
  {
    path: "login",
    canActivate: [alreadyLoggedInGuard],
    loadComponent: () => import("./login/login.view").then((m) => m.LoginView,),
  },
  {
    path: "unauthorized",
    loadComponent: () =>
      import("./unauthorized/unauthorized.view").then(
        (m) => m.UnauthorizedView,
      ),
  },
  {
    path: "**",
    loadComponent: () => import("./not-found.view").then((m) => m.NotFoundView),
  },
];
